let body = document.querySelector("body"),
  productCheck = body.classList.contains("template-product"),
  collectionCheck = body.classList.contains("template-collection"),
  directoryLinks = document.querySelectorAll(".custom--directory-container"),
  careModal = document.getElementById("customer-care"),
  careLink = document.querySelector(".care-title"),
  filterCheck = document.querySelector("#CollectionFiltersForm") !== null,
  mobileCheck = window.innerWidth < 900,
  footerCheck = document.querySelector("footer") !== null;

// if (careModal !== null) {
//   if (mobileCheck) {
//     careLink.textContent = "Help";
//   }
// }

// window.addEventListener("resize", function () {
//   if (careModal !== null) {
//     if (mobileCheck) {
//       careLink.textContent = "Help";
//     }
//   }
// });

function infScroll(container, append) {
  let parent = container.parentNode,
    pagination = parent.querySelector(".pagination"),
    viewMore = document.querySelector(".view-more"),
    btt = document.querySelector(".btt-anchor");

  if (pagination !== null) {
    console.log("pagination exists");

    let infScrollActive = parent.getAttribute("data-scroll");

    if (infScrollActive === "true") {
      console.log("infinite scroll active");

      let viewMoreText = viewMore.querySelector(".view-more__button");
      viewMore.classList.remove("visually-hidden"); // show view more button

      console.log("display view more button");

      infiniteScroll = new InfiniteScroll(container, {
        // options
        hideNav: ".pagination",
        path: ".pagination__step.next",
        append: append,
        history: true,
        historyTitle: true,
        onInit: function () {
          this.on("load", function () {
            console.log("Infinite Scroll load");
          });
          this.on("request", function () {
            console.log("Infinite Scroll request");
            viewMoreText.textContent = "Loading…";
          });
          this.on("append", function (body, path, items, response) {
            if (btt !== null) {
              btt.classList.remove("visually-hidden");
              btt.classList.add("btt-active");
            }
            console.log("Infinite Scroll append path - " + path);
            console.log("Infinite Scroll append length - " + items.length);
            console.log("Infinite Scroll append response - " + response.status);

            viewMoreText.textContent = "View More";
          });
          this.on("error", function () {
            console.log("Infinite Scroll error");
          });
        },
      });
    } else {
      console.log("infinite scroll disabled in settings");
      return;
    }
  } else {
    console.log("no pagination");

    if (btt !== null) {
      btt.classList.add("visually-hidden");
      btt.classList.remove("btt-active");
    }
  }
}

function runScroll() {
  let latestProductGrid = document.querySelector(
    "#CollectionProductGrid .collection-list"
  );
  append = "li.collection-list__item";
  infScroll(latestProductGrid, append);
}

if (collectionCheck) {
  runScroll();
}

window.addEventListener("resize", function () {
  if (collectionCheck) {
    runScroll();
  }
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", function (e) {
    let id = e.detail.sectionId;

    runScroll();
  });
  document.addEventListener("shopify:section:reorder", function (e) {
    let id = e.detail.sectionId;

    runScroll();
  });
  document.addEventListener("shopify:section:unload", function (e) {
    let id = e.detail.sectionId;
    runScroll();
  });
}

class CustomDirectory {
  constructor(target) {
    target.addEventListener("click", this.onDirectoryClick.bind(this));
  }

  onDirectoryClick(event) {
    const parentCheck = event.target.classList.contains("parent-link");

    if (!parentCheck) {
      console.log("normal link");
    } else {
      console.log("parent link");
      event.preventDefault();

      let parent = event.target.parentNode,
        container = parent.parentNode,
        child = container.querySelector(".custom--directory-child-wrap"),
        openClass = child.classList.contains("directory-open");

      const children = document.querySelectorAll(
        ".custom--directory-child-wrap"
      );

      if (window.innerWidth > 1024) {
        if (!openClass) {
          children.forEach((child) => {
            child.classList.add("directory-open");
          });
        } else {
          children.forEach((child) => {
            child.classList.remove("directory-open");
          });
        }
      } else {
        if (!openClass) {
          child.style.display = "block";
          child.classList.add("directory-open");
        } else {
          child.classList.remove("directory-open");
          child.style.display = "none";
        }
      }
    }
  }
}

directoryLinks.forEach((link) => {
  new CustomDirectory(link);
});

const slider = document.querySelector(".custom__slider");

function desktopSlider(slider) {
  if (window.innerWidth > 1024) {
    new Flickity(slider, {
      // options
      cellAlign: "left",
      contain: true,
      cellSelector: ".custom__slide",
      setGallerySize: false,
      arrowShape:
        "M35.2836 13L0 49.9095L35.2836 86.819L39.3694 82.5436L11.2003 53.0708H100V46.7482L11.1982 46.7461L39.3694 17.2754L35.2836 13Z",
    });
  }
}

if (
  productCheck &&
  document.querySelector(".section--main-product").dataset.slider === "true"
) {
  desktopSlider(slider);
}

window.addEventListener("resize", function () {
  if (productCheck) {
    desktopSlider(slider);
  }
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", function (e) {
    let id = e.detail.sectionId;

    desktopSlider(slider);
  });
  document.addEventListener("shopify:section:reorder", function (e) {
    let id = e.detail.sectionId;

    desktopSlider(slider);
  });
  document.addEventListener("shopify:section:unload", function (e) {
    let id = e.detail.sectionId;
    desktopSlider(slider);
  });
}

class CustomerCare {
  constructor(target) {
    target.addEventListener("click", this.onCareClick.bind(this));
  }

  onCareClick(event) {
    let careActive = document
        .querySelector("html")
        .classList.contains("care-active"),
      list = document.querySelector(".care-list"),
      careLink = document.querySelector("a.care-title");

    if (mobileCheck) {
      var span = careLink.querySelector("span.title.mobile");
      var title = span.dataset.title;
    } else {
      var span = careLink.querySelector("span.title.desktop");
      var title = span.dataset.title;
    }

    // event.target.classList.toggle("care-active");
    document.querySelector("html").classList.toggle("care-active");

    if (!careActive) {
      console.log("show " + span + " " + title);
      list.style.display = "flex";
      span.textContent = "×";
    } else {
      console.log("hide " + span + " " + title);
      list.style.display = "none";
      span.textContent = title;
    }
  }
}

new CustomerCare(careLink);

window.addEventListener("click", function (e) {
  if (document.getElementById("customer-care").contains(e.target)) {
  } else {
    if (mobileCheck) {
      var title = careLink.dataset.mobileTitle;
      var span = careLink.querySelector("span.title.mobile");
    } else {
      var title = careLink.dataset.title;
      var span = careLink.querySelector("span.title.desktop");
    }

    document.querySelector("html").classList.remove("care-active");
    careLink.classList.remove("care-active");

    document.querySelector(".care-list").style.display = "none";
    span.textContent = title;
  }
});

function gorgiasReveal(link) {
  let htmlEl = document.querySelector("html");

  link.addEventListener("click", function (e) {
    htmlEl.classList.toggle("gorgias-active");

    let classCheck = htmlEl.classList.contains("gorgias-active");

    if (classCheck) {
      link.textContent = "Close Chat";
    } else {
      link.textContent = link.dataset.text;
    }
  });
}

class SortClick {
  constructor(target) {
    target.addEventListener("click", this.onSortClick.bind(this));
  }

  onSortClick(e) {
    let form = e.target.closest("form");
    // console.log('click ' + form)
    form.classList.toggle("sort-open");
  }
}

// if (filterCheck) {

//   new SortClick(document.querySelector('.sort-wrap button'))
// }

let chatLink = document.querySelector(".js-chat-link");
if (chatLink !== null) {
  gorgiasReveal(chatLink);
}

// Weird empty footer link fix :(

if (footerCheck) {
  // console.log('footer check')
  if (!mobileCheck) {
    // console.log('mobile check')
    let footer = document.querySelector("footer"),
      footerWrapChildren = footer.querySelectorAll(".footer-wrap--new a");

    footerWrapChildren.forEach((child) => {
      child.innerHTML.trim().length == 0
        ? child.remove()
        : console.log("removed");
    });
  }
}

// Click to resume video

var mq = window.matchMedia("(max-width: 1024px)");
var mediaList = document.querySelector(".splide__list");
// var mediaListHasVideo = mediaList.querySelector(".product-media__video") !== null

// if (productCheck && mq.matches) {
//   setTimeout(function resumeAutoplay() {
//     let video = document.querySelector(".product-media__video");

//     if (video === null) {
//       return;
//     } else {
//       // console.log("video found");
//     }

//     video.addEventListener("click", function () {
//       video.play();
//       // console.log("click playing");
//     });
//     video.addEventListener("touchstart", function () {
//       video.play();
//       // console.log("tap playing");
//     });
//   }, 600);
// }

function videoObserver() {
  let slide = document.querySelector(".splide__slide"),
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            let video = entry.target.querySelector("video");
            if (video === null) {
              return;
            }
            video.play();
            // console.log('video play')
          } else {
            let video = entry.target.querySelector("video");
            if (video === null) {
              return;
            }
            video.pause();
            // console.log('video paused')
          }
        });
      },
      {
        threshold: [0, 0.1, 1],
      }
    );
  observer.observe(slide);
}

if (productCheck && mq.matches) {
  videoObserver();
}

function onlyVariantImageLoad() {
  var variantImages = document.querySelectorAll("[data-variant-image]");
  var currentMedia = document.querySelector(".section--main-product").dataset
    .currentVariantMedia;
  let mobile = window.innerWidth < 1024;

  // console.log('hide images')

  variantImages.forEach((image) => {
    if (mobile) {
      if (image.dataset.mediaId != currentMedia) {
        image.classList.add("hidden-variant");
        image.closest("li").classList.remove("is-active");
        image.closest("li").classList.remove("splide__slide");
      }
    } else {
      if (image.dataset.mediaId != currentMedia) {
        image.closest("li").classList.add("visually-hidden");
        image.closest("li").classList.remove("is-visible");
        image.closest("li").classList.remove("is-active");
        image.closest("li").classList.remove("splide__slide");
      }
    }
  });

  // console.log('images hidden')
}

if (productCheck) {
  let onlyCheck =
    document.querySelector(".section--main-product").dataset
      .variantImageBehaviour == "only";
  if (onlyCheck) {
    console.log("only variant image load");
    onlyVariantImageLoad();
  }
} else {
  console.log("all images load");
}
